var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("autocomplete", {
    ref: "geneSelect",
    attrs: {
      placeholder: !_vm.$store.state.geneToQuery
        ? "Search gene"
        : _vm.$store.state.geneToQuery,
      matches: _vm.matchingGenes,
    },
    on: {
      "input-change": function ($event) {
        return _vm.lookupGenes($event)
      },
      "item-select": function ($event) {
        return _vm.selectGene($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }